import { Environment, Space } from 'contentful-management';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import { config, getDeliveryClient, getManagementClient } from '@libraries/contentful';
import AuthStoreModule from '@app/store/modules/AuthStoreModule';
import Axios, { AxiosInstance } from 'axios';
import ResourceNotFoundError from '@app/types/errors/ResourceNotFoundError';

export default class ContentfulService {
	protected deliveryClient = getDeliveryClient();

	protected async getManagementEnvironment(): Promise<Environment> {
		const client: any = await this.managementClient;

		const space: Space = await client.getSpace(config.CONTENTFUL_SPACE_ID);

		return space.getEnvironment(this.environmentId);
	}
	

	protected get managementClient(): any {
		return getManagementClient(this.managementToken);
	}

	protected get axiosManagementClient(): AxiosInstance {
		return Axios.create({
			baseURL: `https://api.contentful.com`,
			timeout: 10000,
			headers: { Authorization: `Bearer ${this.managementToken}` }
		});
	}

	protected get managementToken(): string {
		const authStoreModule: AuthStoreModule = getStoreModule(AuthStoreModule);

		return authStoreModule.managementToken as string;
	}

	protected get spaceId(): string {
		return config.CONTENTFUL_SPACE_ID;
	}

	protected get environmentId(): string {
		return config.CONTENTFUL_ENVIRONMENT;
	}

	protected throwIfResourceNotFoundError(error: Error | unknown, message: string): void {
		if (error instanceof Error && error.name === 'NotFound') {
			throw new ResourceNotFoundError(message);
		}
	}
}
